<template>
  <div class="min-h-screen">
    <div
      :class="[
        'relative w-full h-[197px]',
        'lg:h-[440px]',
        viewingContactDetailsPage && 'hidden lg:block',
      ]"
    >
      <img
        v-if="image"
        :src="image"
        alt=""
        class="absolute inset-0 size-full object-cover"
      >
    </div>
    <div class="flex flex-1 flex-col justify-center px-large py-huge">
      <div class="lg:w-1/3 mx-auto">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

defineProps<{
  image?: string;
}>();

const viewingContactDetailsPage = computed(() => !!(typeof window !== 'undefined' && window.location.hash));
</script>
